import React from 'react';
import HookDoc from '../../components/hookdoc';
import DragDropComponent from '../../examples/useDragDrop.example';
import en from '../../data/en/drag-drop.json';
import sr from '../../data/rs/drag-drop.json';
import { useLanguage } from '../../context/LanguageContext';

function DragDropPage() {
  const { language } = useLanguage();
  const languageData = language === 'en' ? en : sr;
  return (
    <HookDoc data={languageData}>
      <DragDropComponent />
    </HookDoc>
  );
}

export default DragDropPage;
